import commonHelper from '@/app/utility/common.helper.utility';
import invoiceLoaderDetails from './invoiceLoaderDetails';
import DatePicker from 'vue2-datepicker';
export default {
  name: 'invoiceLoader',
  watch: {
    currentPage: function() {
      this.getInvLoaderDtls();
    },
    perPage: function() {
      this.currentPage = 1;
      this.getInvLoaderDtls();
    }
  },
  components: {
    DatePicker,
    invoiceLoaderDetails
  },
  data() {
    return {
      loader: false,
      unsubscribe: null,
      showExcelUploadModal: false,
      perPage: commonHelper.perPageRecord,
      pageOptions: commonHelper.getPageOption(),
      totalRows: null,
      currentPage: 1,
      vendorInvId: null,
      poNum: null,
      vendor: { value: null, text: null },
      invoiceNum: null,
      status: { value: null, text: null },
      employee: { value: null, text: null },
      pending: { value: null, text: null },
      fromDate: null,
      toDate: null,
      dateFilter: ['Invoice Date', 'Reciept Date', 'Submission Date'],
      dateFilterValue: 'Invoice Date',
      invoiceLoaderData: [],
      invoiceLoaderFields: [
        {
          key: 'approval_status'
        },
        {
          key: 'vendor_id',
          label: 'Vendor Code'
        },
        {
          key: 'vendor_name'
        },
        {
          key: 'vendor_site_name'
        },
        {
          key: 'po_num',
          label: 'PO Number'
        },
        {
          key: 'po_status',
          label: 'PO Status'
        },
        {
          key: 'inv_name',
          label: 'Invoice Number'
        },
        {
          key: 'inv_date',
          label: 'Invoice Date'
        },
        {
          key: 'submission_date'
        },
        {
          key: 'receipt_date'
        },
        {
          key: 'receipt_num',
          label: 'Receipt Number'
        },
        {
          key: 'inv_amt',
          label: 'Invoice Amount',
          class: 'fix-tax-amt'
        },
        { key: 'currency', stickyColumn: true },
        {
          key: 'first_party_gstn',
          label: 'Company GSTN'
        },
        {
          key: 'third_party_gstn',
          label: 'Third Party GSTN'
        },
        {
          key: 'status_code',
          label: 'Status'
        },
        {
          key: 'status_msg',
          label: 'Error Message'
        }
      ],
      invLoaderRowSelected: null,
      showInvLoaderDtlsModal: false
    };
  },
  mounted() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'shared/setActionName') {
        const actionName = state.shared.actionName;
        if (actionName === 'upload') {
          this.showHideExcelUpload(true);
        }
      }
    });
  },
  methods: {
    getInvLoaderDtls() {
      const payload = {
        _page: this.currentPage - 1,
        _limit: this.perPage
      };
      this.loader = true;
      this.$store
        .dispatch('invoiceLoader/getInvLoaderDtls', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data.page;
            this.invoiceLoaderData = result;
            this.totalRows = resp.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    rowSelected(item) {
      this.invLoaderRowSelected = item;
      this.showHideInvLoaderDtlsModal(true);
    },
    showHideExcelUpload(flag) {
      this.showExcelUploadModal = flag;
    },
    truncateComment(souce, size) {
      return commonHelper.truncate(souce, size);
    },
    formattingAmount(amount) {
      return commonHelper.formatAmountWithoutCurrency(amount);
    },
    dateChange(ele) {
      this.selectedDate = ele;
      this.toDate = null;
    },
    disabledDates(date) {
      return commonHelper.disabledDates(date, this.selectedDate);
    },
    showHideInvLoaderDtlsModal(flag) {
      this.showInvLoaderDtlsModal = flag;
    },
    clearFilters() {
      this.poNum = null;
      this.invoiceNum = null;
      this.vendor = { value: null, text: null };
      if (this.cardName !== 'Pending Hold Invoices') {
        this.status = { value: null, text: null };
      }
      this.employee = { value: null, text: null };
      this.pending = { value: null, text: null };
      this.assigned = { value: null, text: null };
      this.fromDate = null;
      this.toDate = null;
      this.dateFilterValue = 'Invoice Date';
      this.assignedValue = 'Assigned';
      this.invoiceApprovalData = [];
      this.totalRows = null;
      this.selectAll = false;
      this.currentPage = 1;
      this.showHistoryBtn = false;
    }
  },
  beforeDestroy() {
    this.unsubscribe();
  }
};
